import PropTypes from "prop-types";

export default function RadioInput({ label, value, name, checked, onChange }) {
  return (
    <label>
      <input
        type="radio"
        value={value}
        name={name}
        checked={checked}
        onChange={onChange}
      />
      {label}
    </label>
  );
}

RadioInput.propTypes = {
  label: PropTypes.string.isRequired,
  value: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  checked: PropTypes.bool.isRequired,
  onChange: PropTypes.func.isRequired,
};
